import { Toolbar } from "primereact/toolbar";
import { IPermissionProps } from "../../models/Login";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import React, { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { IModal } from "./Designation";
import { Fetch } from "../../shared/Fetch";

export interface IEmptyDesignation {
    designationId?: number,
    designation_Name?: string,
    add_by_user?: number,
    add_Date?: Date,
};

interface Iprops {
    setModal: (modal: IModal) => void,
    toast: any,
    reload: boolean,
    permissions: IPermissionProps,
    setReload: (is: boolean) => void,
}

export const EmptyDesignation = {
    designation_Name: "",
}

export const Table = (props: Iprops) => {

    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IEmptyDesignation>, loading: boolean });
    const dt = useRef<any>(null);

    const leftToolbarTemplate = () => {
        return (
            props.permissions.is_Create ?
            <React.Fragment>
                <div className="my-2">
                    <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                </div>
            </React.Fragment>: ''
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Designation</h5>
        </div>
    );

    const openNew=()=>{
        props.setModal({ open: true, singleData: EmptyDesignation });
    };
    const openEdit=(rowData: IEmptyDesignation)=>{
        props.setModal({ open: true, singleData: rowData });
    };
    const action=(rowData: IEmptyDesignation)=>{
        return (
            <div className="flex gap-3">
                <Button className="pi pi-pencil text-primary bg-white border-none" onClick={()=>openEdit(rowData)}></Button>
            </div>
        );
    }
    
    const loadTableData = async ()=>{
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("DesignationMast", "GET", null, null, props.toast);
        if(response){
            const data = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }

    useEffect(() => {
        loadTableData();
    }, [props.reload]);

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate}></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows scrollable scrollHeight="75vh"
                value={tableData.tableData}
                emptyMessage="No Requirements found."
                resizableColumns showGridlines columnResizeMode="expand"
                header={header}
                loading={tableData.loading}
            >
                <Column header="SN." body={(data, options) => options.rowIndex + 1}/>
                <Column field="designation_Name" header="Designation Name"/>
                {props.permissions.is_Update && <Column field="" header="Action" body={action} />}
            </DataTable>
        </>
    );
}